import React from "react";

const Advice = () => {
  const adviceData = [
    {
      title: "Transportation in Myrtle Beach",
      content:
        "Consider buying a bicycle as your primary mode of transportation. Many J1 students use bikes to commute. The Coast RTA bus system is also available but has limited routes. If possible, live close to your workplace to save on transportation costs. Popular bike shops often offer special deals for J1 students.",
    },
    {
      title: "Best Areas to Live",
      content:
        "South Myrtle Beach, and areas near Broadway at the Beach are popular among J1 students. These locations offer good access to shopping, entertainment, and work opportunities. Try to avoid North Myrtle Beach if you work in central Myrtle Beach, as the commute can be challenging.",
    },
    {
      title: "Weather Preparation",
      content:
        "Myrtle Beach has very hot and humid summers. Always carry water, use sunscreen, and wear appropriate clothing. Afternoon thunderstorms are common, so keep an umbrella or rain jacket handy. Hurricane season runs from June to November - stay informed about weather updates.",
    },
    {
      title: "Banking and Money Management",
      content:
        "Open a bank account at Bank of America or Wells Fargo - they have multiple branches and ATMs in Myrtle Beach. Many banks offer student accounts with no monthly fees. Keep your tip money separate and maintain a budget for weekly expenses. Always have some emergency funds.",
    },
    {
      title: "Social Life and Entertainment",
      content:
        "Broadway at the Beach is a popular hangout spot with restaurants, shops, and entertainment. Join J1 student Facebook groups to meet others and find events. The beach is free entertainment - take advantage of it! Many attractions offer employee discounts, ask your employer about these perks.",
    },
    {
      title: "Safety Tips",
      content:
        "Always lock your bike and house/apartment. Avoid walking alone at night, especially in tourist areas. Save important phone numbers (police, sponsor, employer) in your phone. Be cautious during peak tourist season as traffic increases significantly. Consider getting basic health insurance.",
    },
    {
      title: "Shopping and Groceries",
      content:
        "Walmart and Food Lion are affordable options for groceries. Tanger Outlets offer good deals on clothing and necessities. Consider sharing bulk purchases with roommates to save money. Download store apps for additional discounts and coupons. The Coastal Grand Mall is also a good shopping destination.",
    },
    {
      title: "Work Culture",
      content:
        "Americans value punctuality - arrive at least 10 minutes early for work. Tipping is a significant part of service industry income. Maintain a positive attitude with customers, even in difficult situations. Don't hesitate to ask questions if you're unsure about something at work.",
    },
    {
      title: "Healthcare and Emergencies",
      content:
        "Know the location of the nearest urgent care centers and hospitals. Grand Strand Medical Center is the main hospital. Keep your insurance card with you at all times. For minor health issues, visit CVS MinuteClinic or Walgreens Healthcare Clinic - they're more affordable than hospitals.",
    },
    {
      title: "Local Resources and Support",
      content:
        "Visit the Myrtle Beach International Student Center for support and information. Join local community Facebook groups to stay informed about events and opportunities. Build good relationships with your employer and coworkers - they can be valuable resources. Keep your sponsor's contact information readily available.",
    },
    {
      title: "BONUS",
      content:
        "In the U.S., the 21-year-old drinking age is strictly enforced. You can't buy alcohol or enter bars if you're underage. Don't risk it—even buying for friends can get you into serious trouble. Stay safe and follow the rules.",
    },
  ];

  return (
    <div className='min-h-screen bg-[#F8F9FA] py-8'>
      <div className='max-w-4xl mx-auto px-4'>
        <h1 className='text-4xl font-bold text-center mb-8 font-architects-daughter text-[#212529]'>
          J1 Student Advice for Myrtle Beach
        </h1>
        <div className='space-y-6'>
          {adviceData.map((advice, index) => (
            <div
              key={index}
              className='bg-white rounded-lg shadow-md overflow-hidden p-6'>
              <h2 className='text-xl font-bold mb-4 font-architects-daughter text-[#212529]'>
                {index + 1}. {advice.title}
              </h2>
              <p className='font-architects-daughter text-[#495057] leading-relaxed'>
                {advice.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Advice;
